<template>
  <div>
    <el-form-item label="占位内容">
      <el-input v-model="data.placeholder" placeholder="占位内容" maxlength="10"></el-input>
    </el-form-item>
    <el-form-item label="数据地址">
      <el-input v-model="data.dataUrl" placeholder="数据地址"></el-input>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: "config-user",
  props: ["data"],
  data() {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null,
      },
    };
  },
  created() {
    this.data.crudMix = {
      data() {
        return {
          page: {
            pageSize: 20,
            pagerCount: 1,
          },
          data: [],
          option: {
            selection: true,
            reserveSelection: true,
            align: "center",
            menuAlign: "center",
            column: [
              {
                label: "id",
                prop: "id",
              },
              {
                label: "姓名",
                prop: "name",
              },
              {
                label: "性别",
                prop: "sex",
              },
            ],
          },
        };
      },
      methods: {
        onLoad(page) {
          this.$message.success("分页信息:" + JSON.stringify(page));
          this.page.total = 40;
          //模拟分页
          if (this.page.currentPage === 1) {
            this.data = [
              {
                id: 1,
                name: "张三",
                sex: "男",
              },
              {
                id: 2,
                name: "李四",
                sex: "女",
              },
            ];
          } else if (this.page.currentPage == 2) {
            this.data = [
              {
                id: 3,
                name: "王五",
                sex: "女",
              },
              {
                id: 4,
                name: "赵六",
                sex: "女",
              },
            ];
          }
        },
        selectionChange(list) {
          this.$message.success("选中的数据" + JSON.stringify(list));
        },
        toggleSelection(val) {
          this.$refs.crud.toggleSelection(val);
        },
      },
    };
  },
  methods: {
    generateRule() {
      const rules = [];
      Object.keys(this.validator).forEach((key) => {
        if (this.validator[key]) rules.push(this.validator[key]);
      });
      this.data.rules = rules;
    },
  },
  watch: {
    "data.required": function (val) {
      if (val)
        this.validator.required = {
          required: true,
          message: `请输入${this.data.label}`,
        };
      else this.validator.required = null;

      this.generateRule();
    },
  },
};
</script>
